import React from 'react';
import { SectionHeader } from '../components/SectionHeader';
import { DetailReadOnlyField } from '../components/DetailFields';
import { DetailFieldRow, DetailValue } from '../components/DetailFields';
import { detailGrid2 } from '../storeDetailsConstants';
import { formatCurrency, formatDetailValue, formatMealOffering } from '../storeDetailsUtils';

export function MenuAvailabilitySection({ meta, store }) {
  const op = store?.kitchen_operation ?? {};

  return (
    <>
      <SectionHeader Icon={meta.Icon} title={meta.title} subtitle={meta.subtitle} />

      <DetailFieldRow label="Regular menu available" description="Customers can order from the regular menu">
        <DetailValue>{op.regularMenuAvailable ? 'Yes' : 'No'}</DetailValue>
      </DetailFieldRow>
      <DetailFieldRow
        label="Subscription menu available"
        description="Customers can order from the subscription menu"
      >
        <DetailValue>{op.subscriptionMenuAvailable ? 'Yes' : 'No'}</DetailValue>
      </DetailFieldRow>
      <DetailFieldRow label="Meal offerings" description="Enabled meal categories for this kitchen">
        <DetailValue>{formatMealOffering(op.meal_offering)}</DetailValue>
      </DetailFieldRow>
      <DetailFieldRow label="Free combo promo agreed" description="Kitchen agreed to free combo promotion">
        <DetailValue>{op.agreedForFreeComboPromo ? 'Yes' : 'No'}</DetailValue>
      </DetailFieldRow>

      <div style={{ ...detailGrid2, marginTop: 16 }}>
        <DetailReadOnlyField
          label="Amount required for combo promo"
          value={formatCurrency(op.amountRequiredForComboPromo)}
        />
        <DetailReadOnlyField
          label="Free promotional delivery"
          value={op.freePromotionalDelivery ? 'Yes' : 'No'}
        />
      </div>
    </>
  );
}
